import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Events.css';

const eventLines = [
    { date: "30.06.23", phase: "PHASE 1", theme: "GENESIS" },
    { date: "23.02.24", phase: "PHASE 2", theme: "MOMENTUM" },
    { date: "06.07.24", phase: "PHASE 3", theme: "SOLSTICE" },
    { date: "11.10.24", phase: "PHASE 4", theme: "DIMENSIONS" },
    { date: "28.02.25", phase: "PHASE 5", theme: "REFLECTIONS" },
    { date: "31.12.25", phase: "PHASE 6", theme: "ANCHOR NYE" },
    { date: "14.03.26", phase: "PHASE 7", theme: "ASCENSION" },
    { date: "26.09.26", phase: "PHASE 8", theme: "ELYSIUM" },
    { date: "09/01/27", phase: "PHASE 9", theme: "RE-RETURN", upcoming: true }
];

function Events() {
    const navigate = useNavigate();
    const [typedLines, setTypedLines] = useState([]);
    const [currentLineIndex, setCurrentLineIndex] = useState(0);
    const [currentCharIndex, setCurrentCharIndex] = useState(0);
    const [isTypingComplete, setIsTypingComplete] = useState(false);

    useEffect(() => {
        if (currentLineIndex >= eventLines.length) {
            setIsTypingComplete(true);
            return;
        }

        const currentLine = eventLines[currentLineIndex];
        const fullLineText = `${currentLine.date}    ${currentLine.phase}    ${currentLine.theme}`;

        if (currentCharIndex <= fullLineText.length) {
            const timer = setTimeout(() => {
                const newTypedLines = [...typedLines];
                newTypedLines[currentLineIndex] = {
                    ...currentLine,
                    typedText: fullLineText.substring(0, currentCharIndex)
                };
                setTypedLines(newTypedLines);
                setCurrentCharIndex(prev => prev + 1);
            }, 50); // Typing speed

            return () => clearTimeout(timer);
        } else {
            // Move to next line after a brief pause
            const timer = setTimeout(() => {
                setCurrentLineIndex(prev => prev + 1);
                setCurrentCharIndex(0);
            }, 300);

            return () => clearTimeout(timer);
        }
    }, [currentLineIndex, currentCharIndex, typedLines]);

    return (
        <div className="events-page">
            {/* Video Background */}
            <div className="events-video-container">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="events-background-video"
                >
                    <source src="/rotb_big.mp4" type="video/mp4" />
                </video>
                <div className="events-video-overlay"></div>
            </div>

            {/* Events Container */}
            <div className="events-container">
                <div className="events-content">
                    <h1 className="events-screen-reader-title">Events</h1>

                    <div className="events-list">
                        {typedLines.map((line, index) => {
                            const parts = line.typedText.split('    ');
                            const showCursor = index === currentLineIndex && currentCharIndex > 0;

                            return (
                                <div key={index} className={`event-line${line.upcoming ? ' event-line-upcoming' : ''}`}>
                                    {line.upcoming && <span className="event-upcoming-label">UP NEXT</span>}
                                    <div className="event-line-content">
                                        <span className="event-date">
                                            {parts[0] || ''}
                                            {showCursor && parts.length === 1 && <span className="typing-cursor">|</span>}
                                        </span>
                                        <span className="event-phase">
                                            {parts[1] || ''}
                                            {showCursor && parts.length === 2 && <span className="typing-cursor">|</span>}
                                        </span>
                                        <span className="event-theme">
                                            {parts[2] || ''}
                                            {showCursor && parts.length >= 3 && <span className="typing-cursor">|</span>}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                </div>
            </div>

            {/* Main Typing Animation (appears after event list is complete) */}
            {isTypingComplete && (
                <div className="events-typing-container">
                    <TypingAnimation />
                </div>
            )}

            {/* Navigation */}
            <div className="events-navigation">
                <button className="home-btn" onClick={() => navigate('/')}>
                    HOME
                </button>
            </div>
        </div>
    );
}

// Separate component for the main typing animation
function TypingAnimation() {
    const [displayText, setDisplayText] = useState('');
    const [showCursor, setShowCursor] = useState(true);
    const [animationPhase, setAnimationPhase] = useState('blinking');
    const [, setBlinkCount] = useState(0);

    const text1 = "H4NDKR4FT3D P4RTI3$";
    const text2 = "[FØR 4 N3W WØRLD]";

    useEffect(() => {
        let interval;

        if (animationPhase === 'blinking') {
            interval = setInterval(() => {
                setShowCursor(prev => !prev);
                setBlinkCount(prev => {
                    if (prev >= 5) {
                        setAnimationPhase('typing');
                        return 0;
                    }
                    return prev + 1;
                });
            }, 500);
        } else if (animationPhase === 'typing') {
            setShowCursor(true);
            let currentIndex = 0;
            const fullText = text1 + '\n' + text2 + '\n';

            interval = setInterval(() => {
                if (currentIndex < fullText.length) {
                    setDisplayText(fullText.substring(0, currentIndex + 1));
                    currentIndex++;
                } else {
                    clearInterval(interval);
                    setShowCursor(false);
                    setAnimationPhase('complete');
                }
            }, 100);
        }

        return () => clearInterval(interval);
    }, [animationPhase]);

    return (
        <div className="typing-text">
            {displayText.split('\n').map((line, index) => (
                <div key={index} className="typing-line">
                    {index === 1 && line.includes('[') ? (
                        <>
                            {line.charAt(0) === '[' && <span className="bracket">[</span>}
                            {line.length > 2 && <span className="bracket-text">{line.slice(1, -1)}</span>}
                            {line.charAt(line.length - 1) === ']' && <span className="bracket">]</span>}
                        </>
                    ) : (
                        line
                    )}
                    {index === displayText.split('\n').length - 1 && showCursor && <span className="cursor">|</span>}
                </div>
            ))}
        </div>
    );
}

export default Events;
